// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.DeletePaymentMethodWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { DeletePaymentMethodWebApiHandler_deletePaymentMethod } from '@zg-rentals/ts-rent-payment-client';

import type { DeletePaymentMethodRequestDto, DeletePaymentMethodResponseDto } from '@zg-rentals/ts-rent-payment-client';

export interface DeletePaymentMethodWebApiHandler_deletePaymentMethod_Args {
  postData: DeletePaymentMethodRequestDto;
}

export type DeletePaymentMethodWebApiHandler_deletePaymentMethod_Options = UseMutationOptions<
  DeletePaymentMethodResponseDto,
  unknown,
  DeletePaymentMethodWebApiHandler_deletePaymentMethod_Args
>;

/**
 * Delete a payment method
 */
export const useDeletePaymentMethodWebApiHandler_deletePaymentMethod = ({
  httpClient,
  ...options
}: Omit<DeletePaymentMethodWebApiHandler_deletePaymentMethod_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: DeletePaymentMethodWebApiHandler_deletePaymentMethod_Args) =>
      DeletePaymentMethodWebApiHandler_deletePaymentMethod(args.postData, httpClient),
  });
};
